<template>
    <div class="container">
        <div class="panel">
            <div class="add" @click="add">添加项目</div>
        </div>
        <div v-for="(item, index) of data" :key="index">
            <slot :item="item" :index="index" />
        </div>
    </div>
</template>

<script>
import service from '../assets/js/service'
export default {
    name: "DataText",
    model: {
        prop: 'data',
        event: 'change'
    },
    props: {
        flag: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        }
    },
    methods: {
        add() {
            let temp = Object.assign({}, this.data[0])
            temp.title = '请编辑此处内容'
            temp.content = '请编辑此处内容'
            this.data.push(temp)
        }
    },
    mounted() {
        service.add(this.flag)
    }
};
</script>

<style scoped>
.container {
    position: relative;
    z-index: 10;
}

.container >>> .panel {
    top: -18px;
    left: -20px;
    right: -20px;
    bottom: -78px;
    position: absolute;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 0 30px rgba(0, 0, 0, .15);
    background: #fff;
    z-index: -1;
    display: none;

    align-items: flex-end;
    justify-content: center;
}

.add {
    padding: 12px 0;
    color: #666;
    width: 95%;
    text-align: center;
    line-height: 100%;

    border: 1px solid #dedede;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    border-radius: 2px;

    margin-bottom: 20px;
    font-size: 13px;
    cursor: default;
}

.add:hover {
    color: #555;
    border: 1px solid #999;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
}

.panel:hover {
    display: flex;
}

.container:hover >>> .panel {
    display: flex;
}

</style>
